/**
 * 主页/home
 */
const homeLangCN = {
    new:"新品",
    hot:"热卖",
    newProduct: "新品推荐",
    hotProduct: "人气推荐",
    shopping:"购物",
    BrandManufacturing:"品牌",
    more:"更多",
    goodsRecommendedation:"商品推荐",
    moreGoods:"更多商品",
}

const homeLangEN = {
    new:"New goods",
    hot:"Hot sale",
    newProduct: "New goods",
    hotProduct: "Recommended for you",
    shopping:"Purchase",
    BrandManufacturing:"Brand",
    more:"More",
    goodsRecommendedation:"Products recommendations",
    moreGoods:"More",
}


const langPackage = {
    cn:homeLangCN,
    en:homeLangEN
}

export {langPackage}
